import React from "react";
import styles from "../styles/Home.module.scss";
import dynamic from "next/dynamic";
import HomePageServices from "./HomePageServices";
const KCOnlinePlatroms = dynamic(() => import("./OnlinePlatforms"));
const WebinarEvents = dynamic(() => import("./WebinarEvents"), { ssr: false });
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import CustomImage from "./CustomImage";
const FeaturedBlogs = dynamic(() => import("./FeaturedBlogs"), { ssr: false });
const TopTieUpsOfKC = dynamic(() => import("./UniTieUp"), { ssr: false });
const KcNewLatestUpdates = dynamic(() => import("./kcNewlatestupdates"));
import VisibilitySensorComponent from "./VisibilitySensorComponent";
import Head from "next/head";
import LazyReveal from "./LazyReveal";
import Link from "next/link";
import { getOnboardingOrFormCtaProps } from "../utils/applyCtaButtonProps";
import { useRouter } from "next/router";
import { persistSourceContext } from "../utils/b2c/sourceTracking";
import { PRIMARY_SOURCE_B2C_WIDGET } from "../utils/b2c/constants";
import { useB2cFlag } from "../hooks/useB2cFlag";
const KcNews = dynamic(() => import("./KcNews"));

const Homepage: React.FC = (props: any) => {
  const {
    title,
    description,
    coreStrengths: { coreTitle, sections },
    services,
    advantageTitle,
    advantageSubTitle,
    advantageDesc,
    heroSectionBtn,
  } = props.homePageData;

  const router = useRouter();
  const b2cEnabled = useB2cFlag();

  const applyCtaButtonProps = getOnboardingOrFormCtaProps(router, {
    btnLink: heroSectionBtn?.btnLink,
    formId: heroSectionBtn?.formId,
    toOnboardingEnabled: b2cEnabled && Boolean(heroSectionBtn?.toOnboardingEnabled),
    sourceUrl: "home",
  });

  return (
    <>
      <Head>
        <link
          rel="preload"
          as="image"
          href={props.homePageData.mainImageUrl || "/images/girl.png"}
          imageSrcSet={`${props.homePageData.mainImageUrl || "/images/girl.png"} 640w`}
          imageSizes="(max-width: 767px) 640px, 100vw"
          fetchPriority="high"
        />
        <link
          rel="preload"
          as="image"
          href="/new-palace.png"
          fetchPriority="high"
        />
      </Head>
      <div id="homepage" className={styles.dynamicBg}>
        <Container>
          <div className={styles.mainSectionBg}>
            <img
              src="/new-palace.png"
              alt=""
              aria-hidden="true"
              className={styles.mainSectionBgBgImage}
              loading="eager"
              fetchPriority="high"
              decoding="async"
            />
            <Row>
              {/* Image Column - Mobile First */}
              <Col xs={12} lg={6} className="order-lg-2">
                <div
                  id="headImg"
                  className={`${styles.mainContent} text-center`}
                >
                  <div className={styles.heroImageWrapper}>
                    <picture>
                      <source
                        media="(max-width: 767px)"
                        srcSet={
                          props.homePageData.newMainImageUrl?.imageUrl ||
                          "/images/girl.png"
                        }
                      />
                      <source
                        media="(min-width: 768px)"
                        srcSet={
                          props.homePageData.newMainImageUrl?.imageUrl ||
                          "/images/girl.png"
                        }
                      />
                      <img
                        src={
                          props.homePageData.newMainImageUrl?.imageUrl ||
                          "/images/girl.png"
                        }
                        alt={
                          props.homePageData.newMainImageUrl?.alt ||
                          "Hero image"
                        }
                        width="640"
                        height="507"
                        className={styles.responsiveHeroImage}
                        loading="eager"
                        fetchPriority="high"
                        decoding="async"
                      />
                    </picture>
                  </div>
                </div>
              </Col>

              {/* Text Column */}
              <Col xs={12} lg={6} className="order-lg-1">
                <div id="headText" className={styles.mainContent}>
                  <h1>{title}</h1>
                  <p>{description}</p>
                  <Button
                    id="enquirebt"
                    variant="primary"
                    size="lg"
                    onClick={(e) => {
                      if (
                        applyCtaButtonProps.mode === "onboarding" &&
                        typeof window !== "undefined"
                      ) {
                        persistSourceContext({
                          sourceUrl: window.location.href,
                          primarySource: PRIMARY_SOURCE_B2C_WIDGET,
                          fifthStepVisible:
                            heroSectionBtn?.onBoardingFlow?.nearestOffice ?? true,
                          coachingVisible:
                            heroSectionBtn?.onBoardingFlow?.lookingForCoaching ?? true, // CFM-1514
                        });
                      }
                      applyCtaButtonProps.onClick?.(e);
                    }}
                    className={applyCtaButtonProps.formClassName}
                  >
                    {heroSectionBtn?.btnTitle ?? "Start Your Journey"}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <div id="strengths-core" className={styles.Strengths}>
        <Container>
          <div className="text-center">
            <h2>{coreTitle}</h2>
          </div>
          {/* <VisibilitySensorComponent> */}
          <Row id="core-strenths" className="text-center">
            {sections.length > 0 &&
              sections?.map((section: any, ind: number) => {
                const { count, sectionTitle, sectionDesc, color, href } =
                  section;
                return (
                  <Col xs={12} md={4} lg={4} key={ind}>
                    <div className={styles.StrengthsContent}>
                      <a href={href}>
                        <h2
                          style={{
                            color: color,
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <VisibilitySensorComponent end={count} />+
                        </h2>
                        <h3>{sectionTitle}</h3>
                      </a>
                      <p>{sectionDesc}</p>
                    </div>
                  </Col>
                );
              })}
          </Row>
          {/* </VisibilitySensorComponent> */}
        </Container>
      </div>
      <HomePageServices sectionData={services} />
      <LazyReveal className={styles.multiCountry}>
        <Container>
          <Row>
            <Col id="multi-countryimage" xs={12} lg={6} md={6}>
              <h2 className="d-block d-sm-none"> {advantageTitle}</h2>
              <CustomImage
                src={
                  props?.homePageData?.multicountryImageUrl
                    ?.newMultiCountryImage?.imageUrl ||
                  "/images/multi-country.svg"
                }
                alt={
                  props?.homePageData?.multicountryImageUrl
                    ?.newMultiCountryImage?.alt
                }
                width={535}
                height={599}
              />
            </Col>
            <Col id="multi-countrytxt" xs={12} lg={6} md={6}>
              <div className={styles.multi_country_content}>
                <h2 className="d-none d-sm-block">{advantageTitle}</h2>
                <h3>{advantageSubTitle}</h3>
                <p>{advantageDesc}</p>
                <div
                  id="ExploreCountries"
                  className={`${styles.viewMore}`}
                  onClick={() => (window.location.href = "/study-destinations")}
                >
                  Explore Countries
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <div id="multi-countryimages" className={styles.WebinarHomeLineImg}>
          <CustomImage
            src="/new-images/webinar-home-page-line.svg"
            alt="webinarHomePageLine.svg"
            width={126}
            height={87}
          />
        </div>
      </LazyReveal>
      <LazyReveal className={styles.webinarEventsMianSection}>
        <div>
          <WebinarEvents headingLevel={2}/>
        </div>
      </LazyReveal>

      <LazyReveal className={styles.homePageKcOnlinePlatform}>
        <KCOnlinePlatroms {...props} />
      </LazyReveal>

      <LazyReveal className={styles.homepageUniTieUp}>
        <TopTieUpsOfKC />
      </LazyReveal>
      <LazyReveal className={styles.homekcNewLatestUpdate}>
        <KcNewLatestUpdates {...props} />
      </LazyReveal>
      <LazyReveal className={styles.homePageBlogs}>
        <FeaturedBlogs />
      </LazyReveal>
      <KcNews {...props} />
    </>
  );
};

export default Homepage;
